import React, { useState } from "react";
import userImg from "../../images/user.png";
import "../../Styles/yellowcalf.css/Header.css";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";

const Header = () => {
  const [showMsg, setShowMsg] = useState(false);
  const [showUser, setShowUser] = useState(false);
const username = localStorage.getItem("username") || "Accountant";


  return (
    <header
      style={{
        height: "60px",
        background: "#ffffff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 15px",
        borderBottom: "1px solid #e5e5e5",
      }}
    >
      <div></div>

      <ul
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          listStyle: "none",
          margin: 0,
        }}
      >
        {/* Language */}
        {/* <li>
          <select
            onChange={(e) => (window.location.href = e.target.value)}
            style={{
              background: "transparent",
              color: "#333",
              border: "none",
              outline: "none",
              cursor: "pointer",
            }}
          >
            <option value="/site/language?lang=en">English</option>
            <option value="/site/language?lang=ar">Arabic</option>
            <option value="/site/language?lang=pt">Portuguese</option>
            <option value="/site/language?lang=sp">Spanish</option>
          </select>
        </li> */}

        {/* Message Icon */}
        {/* <li style={{ position: "relative" }}>
          <span
            style={{ cursor: "pointer", color: "#333" }}
            onClick={() => {
              setShowMsg(!showMsg);
              setShowUser(false);
            }}
          >
            ✉
          </span>

          <span
            style={{
              position: "absolute",
              top: "-6px",
              right: "-8px",
              background: "red",
              color: "#fff",
              fontSize: "8px",
              padding: "2px 5px",
              borderRadius: "50%",
            }}
          >
            0
          </span>

          {showMsg && (
            <div
              style={{
                position: "absolute",
                top: "35px",
                right: 0,
                width: "220px",
                background: "#fff",
                border: "1px solid #ddd",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                zIndex: 1000,
              }}
            >
              <div style={{ padding: "10px", fontSize: "13px" }}>
                No new messages
              </div>
            </div>
          )}
        </li> */}

        {/* User */}
        <li style={{ position: "relative" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
              color: "#333",
            }}
            onClick={() => {
              setShowUser(!showUser);
              setShowMsg(false);
            }}
          >
            <img
              src="https://stage.edsys.in/uploads/general/user.png"
              alt="User"
              style={{
                width: "26px",
                height: "26px",
                borderRadius: "50%",
              }}
            />
            <span>
      {username} <span style={{ fontSize: "8px" }}>▼</span>
            </span>
          </div>

          {showUser && (
            <div
              style={{
                position: "absolute",
                top: "35px",
                right: 0,
                width: "125px",
                background: "#fffcfeff",
                border: "1px solid #333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                zIndex: 1000,
              }}
            >
              <Link
                to="/accountant/profile"
                style={{ textDecoration: "none", color: "#333" }}
              >
                <div style={itemStyle}>👤 My Profile</div>
              </Link>
              {/* <div style={itemStyle}>✉ My Messages</div>
              <div style={itemStyle}>🔒 Lock Screen</div> */}
              {/* <div style={itemStyle}>⏻ Logout</div> */}
            </div>
          )}
        </li>
      </ul>
    </header>
  );
};

const itemStyle = {
  padding: "10px",
  fontSize: "13px",
  cursor: "pointer",
  borderBottom: "1px solid #f1f1f1",
};

export default Header;
